<template>
  <div class="ellipsis_tooltip_wrap" @mouseenter="checkOverflow">
    <span ref="text" class="ellipsis_tooltip_text z_ellipsis1">{{ text }}</span>
    <span v-if="isOverflow && text" class="ellipsis_tooltip_bubble">
      {{ text }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      isOverflow: false
    };
  },
  methods: {
    checkOverflow() {
      this.$nextTick(() => {
        const textEl = this.$refs.text;
        this.isOverflow = textEl ? textEl.scrollWidth > textEl.clientWidth : false;
      });
    }
  },
  mounted() {
    this.checkOverflow();
    window.addEventListener("resize", this.checkOverflow);
  },
  updated() {
    this.checkOverflow();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkOverflow);
  }
};
</script>

<style>
.ellipsis_tooltip_wrap {
  position: relative;
  overflow: visible;
}
.ellipsis_tooltip_text {
  display: inline-block;
  width: 100%;
  height: 100%;
  line-height: inherit;
}
.ellipsis_tooltip_bubble {
  display: none;
  position: absolute;
  left: 0;
  bottom: 34px;
  z-index: 100;
  max-width: 360px;
  min-width: 100%;
  padding: 8px 12px;
  line-height: 20px;
  color: #ffffff;
  font-size: 14px;
  white-space: normal;
  word-break: break-all;
  background-color: rgba(40, 40, 40, 0.92);
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  pointer-events: none;
  box-sizing: border-box;
}
.ellipsis_tooltip_bubble::after {
  content: "";
  position: absolute;
  left: 18px;
  bottom: -6px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid rgba(40, 40, 40, 0.92);
}
.ellipsis_tooltip_wrap:hover .ellipsis_tooltip_bubble {
  display: block;
}
</style>
